// v2/components/Lightbox.js — ortak tam ekran gorsel goruntuleyici
// Ok tuslari / butonlarla gezinir, Esc veya arka plan tiklamasi kapatir.
// ProductDetailModal ve CartTable ayni bileseni kullanir.
import React, { useState, useEffect, useCallback } from 'react';
import { X } from 'lucide-react';
import styles from './Lightbox.module.css';

export default function Lightbox({ kareler = [], baslangic = 0, baslik = '', onClose }) {
  const [i, setI] = useState(baslangic);
  const [bozuk, setBozuk] = useState({});

  const gecerli = kareler.filter((_, n) => !bozuk[n]);

  const onceki = useCallback(
    () => setI((n) => (n - 1 + kareler.length) % kareler.length), [kareler.length]);
  const sonraki = useCallback(
    () => setI((n) => (n + 1) % kareler.length), [kareler.length]);

  useEffect(() => {
    const tus = (e) => {
      if (e.key === 'Escape') onClose();
      else if (e.key === 'ArrowLeft') onceki();
      else if (e.key === 'ArrowRight') sonraki();
    };
    document.addEventListener('keydown', tus);
    const eskiOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', tus);
      document.body.style.overflow = eskiOverflow;
    };
  }, [onClose, onceki, sonraki]);

  if (!kareler.length || !gecerli.length) return null;

  return (
    <div className={styles.katman} onClick={onClose}
         role="dialog" aria-modal="true"
         aria-label={`${baslik} — görsel ${i + 1}/${kareler.length}`}>
      <button type="button" className={styles.kapat} onClick={onClose} aria-label="Kapat">
        <X size={22} />
      </button>

      {kareler.length > 1 && (
        <button type="button" className={`${styles.ok} ${styles.okSol}`}
                onClick={(e) => { e.stopPropagation(); onceki(); }}
                aria-label="Önceki görsel">‹</button>
      )}

      <img
        className={styles.gorsel}
        src={kareler[i]}
        alt={baslik}
        onClick={(e) => e.stopPropagation()}
        onError={() => setBozuk((b) => ({ ...b, [i]: true }))}
        decoding="async"
      />

      {kareler.length > 1 && (
        <button type="button" className={`${styles.ok} ${styles.okSag}`}
                onClick={(e) => { e.stopPropagation(); sonraki(); }}
                aria-label="Sonraki görsel">›</button>
      )}

      {kareler.length > 1 && (
        <div className={styles.sayac}>{i + 1} / {kareler.length}</div>
      )}
    </div>
  );
}
